import styled from "styled-components";

import { MicroHeader } from "../../../../../../shared/styles/typography/MicroHeader.styled";

const FlightTime = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px 16px 0px 16px;

  @media all and (max-width: ${({ theme }) => theme.mobileBreakingPoint}) {
    border: none;

    ${MicroHeader} {
      margin-top: 8px;
      font-size: ${({ theme }) => theme.fonts.summary.fontSize};
      line-height: ${({ theme }) => theme.fonts.summary.lineHeight};
      letter-spacing: ${({ theme }) => theme.fonts.summary.letterSpacing};
    }
  }
`;

export default FlightTime;
